import { FC, lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import OutletWrapper from '../outletWrapper/OutletWrapper'
import PageLoader from '@/components/loading/PageLoader'
import { MainRoutes } from '@/config/route.config';
import Login from '@/components/auth/Login';
import { LoginCallback } from '@okta/okta-react';
import { RequiredAuth } from '@/components/auth/ProtectedRoute';
import LoginErrorComponent from '@/components/auth/LoginErrorComponent';
import Loading from '@/components/loading-app/Loading';
import UploadMain from '@/pages/upload-signature/upload-main';
import UploadSignature from '@/pages/upload-signature/upload-signature';
import UploadStamp from '@/pages/upload-signature/upload-stamp';
import FormUtility from '@/pages/form-utility/form-utility';
import UpdateUnderwriterUtility from '@/pages/update-underwriter/UpdateUnderwriterUtility';
import UploadSignatureSearch from '@/pages/upload-signature/upload-signature-search';

const LandingPage = lazy(() => import("@/components/landing-page/HomeLandingPage"));
const PolicyStatus = lazy(() => import("@/pages/policy-status-update/PolicyStatusUpdateUtility"));
const PolicyNumber = lazy(() => import("@/pages/policy-number-update/PolicyNumberUpdateUtil"));
const LOA = lazy(() => import("@/pages/loa/LOA"));
const UpdatePolicyScript = lazy(() => import("@/pages/script-run-ui/UpdateInvoiceStatus"));
const UpdateDeletedClaimScript = lazy(() => import("@/pages/script-run-ui/ClaimsCoverageUpdate"));
const UpdateClaimNumberScript = lazy(() => import("@/pages/script-run-ui/ClaimsNumberUpdate"));
const DataScriptApproval = lazy(() => import("@/pages/script-run-ui/DataScriptApproval"));

const AuthorizedLayout: FC = () => {
    return (
        <>
            <main className="main-wrapper">
                <Suspense fallback={<PageLoader show={true} />} />

                <Routes>                    
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/login/callback"
                        element={
                            <LoginCallback
                                loadingElement={<Loading />}
                                errorComponent={LoginErrorComponent}
                            />
                        }
                    />
                    {/* Public with shared layout */}
                    <Route element={<OutletWrapper />}></Route>
                    
                    <Route element={<RequiredAuth />}>
                        <Route element={<OutletWrapper />}>
                            <Route path="/" element={<Navigate to={MainRoutes.HOME} replace />} />
                            <Route path={MainRoutes.HOME} element={<LandingPage />} />
                            <Route path={MainRoutes.DATA_SCRIPT_APPROVAL} element={<DataScriptApproval />} />
                            <Route path={MainRoutes.DATA_SCRIPT_PP_APPROVAL} element={<DataScriptApproval />} />
                            <Route path={MainRoutes.POLICY_STATUS_UPDATE} element={<PolicyStatus />} />
                            <Route path={MainRoutes.POLICY_NUMBER_UPDATE} element={<PolicyNumber />} />
                            <Route path={MainRoutes.FORM_UTILITY} element={<FormUtility />} />
                            <Route path={MainRoutes.UPDATE_UNDER_WRITER} element={<UpdateUnderwriterUtility />} />
                            <Route path={MainRoutes.UPDATE_INVOICE_STATUS} element={<UpdatePolicyScript />} />
                            <Route path={MainRoutes.UPDATE_INVOICE_STATUS_PARAM} element={<UpdatePolicyScript />} />
                            <Route path={MainRoutes.UPDATE_INVOICE_STATUS_PP_PARAM} element={<UpdatePolicyScript />} />
                            <Route path={MainRoutes.UPDATE_CLAIM_NUMBER} element={<UpdateClaimNumberScript />} />
                            <Route path={MainRoutes.UPDATE_DELETED_CLAIMS} element={<UpdateDeletedClaimScript />} />
                            <Route path={MainRoutes.UPLOAD_SIGNATURE} element={<UploadMain />}>
                                <Route index element={<Navigate to="search" replace />} />
                                <Route path="search" element={<UploadSignatureSearch />} />
                                <Route path="signatures" element={<UploadSignature />} />
                                <Route path="stamps" element={<UploadStamp />} />
                            </Route>
                            <Route path={MainRoutes.LOA} element={<LOA />} />
                        </Route>
                    </Route>

                </Routes>
            </main>
        </>
    )
}

export default AuthorizedLayout;